import { Navigate } from "react-router-dom";
import { hasPermission } from "./auth/authUtils";

const ProtectedRoute = ({ module, action, children }) => {
    return hasPermission(module, action) ? children : <Navigate to="/unauthorized" />;
};

export default ProtectedRoute;